import Menu from "@/components/layout/menu.vue";
import MenuEnterprise from "@/components/layout/menu_enterprise.vue";
import { mapState } from "vuex";

export default {
  components: {
    Menu,
    MenuEnterprise
  },
  computed: {
    ...mapState({
      role: state => state.Authenticate.role
    })
  },
  data: () => ({
    //
  })
};
